import { render, staticRenderFns } from "./ChooseMethod.vue?vue&type=template&id=ec59df2c&scoped=true&lang=pug&"
import script from "./ChooseMethod.vue?vue&type=script&lang=js&"
export * from "./ChooseMethod.vue?vue&type=script&lang=js&"
import style0 from "./ChooseMethod.vue?vue&type=style&index=0&id=ec59df2c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec59df2c",
  null
  
)

export default component.exports